type AnyStyle = Record<string, unknown>;

export const isEmptyStyle = (style?: AnyStyle): boolean => {
  if (!style) return true;

  const isEmpty = Object.keys(style).reduce<boolean>((acc, k) => {
    if (typeof style[k] === 'object') {
      return acc && isEmptyStyle(style[k] as AnyStyle);
    }

    // Ignore internal '_...' aphrodite props
    return acc && k.startsWith('_');
  }, true);

  return isEmpty;
};
